export const lunchMenuDate = "19.10.2026";

const lunchSections = [
  {
    title: "Супи",
    title_en: "Soups",
    items: [
      {
        name: "Супа топчета",
        name_en: "Meatball Soup",
        desc: "",
        desc_en: "",
        weight: "300 г",
        weight_en: "300 g",
        price: "4.90 €",
        active: true,
      },
    ],
  },
  {
    title: "Салати",
    title_en: "Salads",
    items: [
      {
        name: "Гръцка салата",
        name_en: "Greek Salad",
        desc: "",
        desc_en: "",
        weight: "200 г",
        weight_en: "200 g",
        price: "5.50 €",
        active: true,
      },
    ],
  },
  {
    title: "Пица",
    title_en: "Pizza",
    items: [
      {
        name: "Пица Прошуто е Фунги",
        name_en: "Prosciutto e Funghi Pizza",
        desc: "",
        desc_en: "",
        weight: "400 г",
        weight_en: "400 g",
        price: "10.90 €",
        active: true,
      },
    ],
  },
  {
    title: "Основни ястия",
    title_en: "Main Courses",
    items: [
      {
        name: "Пилешко бутче с бял ориз и зеленчуци",
        name_en: "Chicken Drumstick with White Rice and Vegetables",
        desc: "",
        desc_en: "",
        weight: "350 г",
        weight_en: "350 g",
        price: "8.20 €",
        active: true,
      },
    ],
  },
  {
    title: "Десерти",
    title_en: "Desserts",
    items: [
      {
        name: "Шоколадово суфле с топка сладолед ванилия",
        name_en: "Chocolate Soufflé with a Scoop of Vanilla Ice Cream",
        desc: "",
        desc_en: "",
        weight: "170 г",
        weight_en: "170 g",
        price: "4.90 €",
        active: true,
      },
    ],
  },
];

export default lunchSections;
